export default __webpack_public_path__ + "static/media/YAS0320.34I-29781_-17226_0.35e1065d.jpg";